import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VContainer,[_c(VRow,_vm._l((_vm.counts[_vm.getScreenSize]),function(i){return _c(VCol,{key:i,attrs:{"sm":"6","xs":"12","md":"4","lg":"4","cols":"12"}},[_c(VCard,{attrs:{"tile":""}},[_c(VCardText,[_c(VSkeletonLoader,{attrs:{"height":_vm.cardHeight - _vm.offset,"tile":"","type":_vm.loaderType}})],1)],1)],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }